initLottie(1);
initLottie(2);

function getCanonicalColor() {
	if (typeof towersArray !== "undefined" && towersArray.length && towersArray[0].color) {
		return towersArray[0].color;
	}
	var checked = document.querySelector('input[name="color"]:checked');
	return checked ? checked.value : "WHITE";
}

function moveTower(fromIndex, toIndex) {
	const closet = {
		color: getCanonicalColor(),
		towers: [],
	};
	towersArray.forEach((t) => {
		closet.towers.push({
			width: t.width.selectedValue,
			topOption: t.topOptions.selectedValue,
			bottomOption: t.bottomOptions.selectedValue,
			doorOption: t.doorOptions.selectedValue,
		});
	});

	if (toIndex >= 0 && toIndex < closet.towers.length) {
		[closet.towers[fromIndex], closet.towers[toIndex]] = [
			closet.towers[toIndex],
			closet.towers[fromIndex],
		];
	}
	resetScene({ instant: true });
	buildCloset(closet, { isChanged: true });
}

//mobile actions expand
const actionsWrapper = document.querySelector(".mc-actions-wrapper");
let actions = actionsWrapper.querySelector(".mc-actions-mobile");
const plusIcon = actionsWrapper.querySelector('.mc-actions-toggle-vertical');

actionsWrapper.addEventListener("click", (event) => {
	document.addEventListener("click", toggleOptions);
});

function toggleOptions(event) {
	console.log('plusIcon', window.getComputedStyle(plusIcon).display);
	if (window.getComputedStyle(plusIcon).display == 'none' && event.target.classList.contains('mc-actions-toggle') || !actionsWrapper.contains(event.target)) {
		actionsWrapper.classList.remove('mc-actions-wrapper-expand');
		setTimeout(() => {
			actions.style.setProperty("transition", "visibility 0s ease 0.2s");
		}, 200);
		document.removeEventListener("click", toggleOptions);
	} else {
		actionsWrapper.classList.add('mc-actions-wrapper-expand');
		setTimeout(() => {
			actions.style.setProperty("transition", "none");
			console.log("transition", window.getComputedStyle(actions).transition);
		}, 200);
	}
}

function disableAddtoCart() {
	const addToCartBtn = document.querySelector('.mc-checkout-addtocard');
	if (!addToCartBtn.classList.contains('add-to-cart-btn-disabled')) {
		addToCartBtn.classList.add('add-to-cart-btn-disabled');
	}
}

function enableAddtoCart() {
	const addToCartBtn = document.querySelector('.mc-checkout-addtocard');
	if (addToCartBtn.classList.contains('add-to-cart-btn-disabled')) {
		addToCartBtn.classList.remove('add-to-cart-btn-disabled');
	}
}
function disableAddtoCart() {
	const addToCartBtn = document.querySelector(".mc-checkout-addtocard");
	if (!addToCartBtn.classList.contains("add-to-cart-btn-disabled")) {
		addToCartBtn.classList.add("add-to-cart-btn-disabled");
	}
}

function enableAddtoCart() {
	const addToCartBtn = document.querySelector(".mc-checkout-addtocard");
	if (addToCartBtn.classList.contains("add-to-cart-btn-disabled")) {
		addToCartBtn.classList.remove("add-to-cart-btn-disabled");
	}
}

function editWidth(towerToEdit, width) {
	console.log("editWidth", towerToEdit, width);
	const closet = {
		color: getCanonicalColor(),
		towers: [],
	};
	towersArray.forEach((t, index) => {
		let tower = {
			width: t.width.selectedValue,
			topOption: t.topOptions.selectedValue,
			bottomOption: t.bottomOptions.selectedValue,
			doorOption: t.doorOptions.selectedValue,
		};
		if (index == towerToEdit - 1) {
			tower.width = `${width}`;
			tower.doorOption =
				width == 30 ? tower.doorOption + "s" : tower.doorOption.slice(0, -1);
		}
		closet.towers.push(tower);
	});
	resetScene({ instant: true });
	buildCloset(closet, { isChanged: true });
	towersArray[towerToEdit - 1].toggleTower();
}

function removeTower(towerIndex) {
	const closet = {
		color: getCanonicalColor(),
		towers: [],
	};
	towersArray.forEach((t, i) => {
		if (i != towerIndex) {
			closet.towers.push({
				width: t.width.selectedValue,
				topOption: t.topOptions.selectedValue,
				bottomOption: t.bottomOptions.selectedValue,
				doorOption: t.doorOptions.selectedValue,
			});
		}
	});
	resetScene({ instant: true });
	buildCloset(closet, { isChanged: true });
}

function resetScene(instant = false) {
	towersArray.forEach((tower) => {
		console.log(tower, "tower");
		document.CabinetVars.SelectedIndex = tower.towerCounter - 1;
		tower.topOptions.selectOption("none");
		tower.bottomOptions.selectOption("none");
		tower.doorOptions.selectOption("none");
		document.App.removeObjectFromSelectedCabinet([document.App.spaceId.MIDDLE]);
		tower.delete();
	});
	let towers = document.querySelector(".mc-towers");
	towers.innerHTML = "";
	towerCounter = 0;
	towersArray = [];
	document.App.resetScene(instant);
	isAddTowerEnabled("active");
	document.isChanged = false;
}

function closetDB(id = 0, action = "get", closetData = {}, draftOrder = false) {
	const endpoint = `https://modular-bundles--development.gadget.app/milano/${action}/${id}`;

	console.log(`Function closetDB called with action ${action} draftOrder: ${draftOrder}`);

	// If the action is 'saveNoAccount', attempt to get the email from an input with a specific ID.
	if (action === "saveNoAccount") {
		// Define an array of possible input IDs for the email.
		const possibleEmailInputs = [
			"reset-password-email",
			"mc-email",
			"mc-login-email",
		];
		let emailInput = null;

		// Try to find the first non-empty input field.
		for (const inputId of possibleEmailInputs) {
			const inputElement = document.getElementById(inputId);
			if (inputElement && inputElement.value.trim()) {
				emailInput = inputElement;
				break; // Stop searching after finding the first valid input.
			}
		}

		if (emailInput && emailInput.value) {
			// Add the email to the closetData if the email input exists and has a value.
			closetData.email = emailInput.value.trim().toLowerCase();
		} else {
			// Log error or handle cases where email cannot be found or is empty.
			console.error("Email input not found or the value is empty.");
			throw new Error("Email input not found or the value is empty.");
		}
	}

	if (draftOrder) {
		closetData.draftOrder = true;
	}

	return fetch(endpoint, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(closetData),
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			return response.json();
		})
		.then((data) => {
			return data;
		})
		.catch((error) => {
			console.error("Error:", error);
			throw error;
		});
}
function saveCloset(closet, variants, action, draftOrder = false) {
	let designId = getUrlParameter("designId");
	// const action = designId ? 'edit' : 'add';

	// Convert designId to a number if not falsy, otherwise default to 0
	let idForDb = designId ? parseInt(designId, 10) : 0;

	// "Save a new design" (override popup): force a create so the original design
	// is kept; the response then makes the new design the current one.
	if (action === "save" && window.__mcSaveAsNew) {
		idForDb = 0;
		window.__mcSaveAsNew = false;
	}

	let returnedClosetData;

	closetDB(idForDb, action, closet, draftOrder)
		.then((data) => {
			console.log("save response: ", data);
			//get returned closetId - data.closetId
			if (action == "save" || action == "saveNoAccount") {
				const url = new URL(window.location);
				url.searchParams.set("designId", data.closetId);
				history.pushState({ path: url.toString() }, "", url.toString());
				console.log("Closet saved:", data.closetId);
				designId = data.closetId;
				console.log("designId newly updated:", designId);
				returnedClosetData = data;
			} else {
				updateShopifyCart(
					action,
					"Milano",
					data.closetId,
					data.name || null,
					data.shopifyImage,
					data.awsImage,
					variants,
					draftOrder
				);
			}
		})
		.catch((error) => {
			console.log("Save closet Error: ", error);
			throw error;
		})
		.finally(() => {
			if (action == "saveNoAccount") {
			} else if (action == "save") {
				console.log("returnedClosetData", returnedClosetData);
				loadingAnimation("done", ".mc-popup-lottie", ".mc-popup-btn-content");
				showPopup("milano-saved-popup", returnedClosetData);
				// exitPopup();
			} else {
				loadingAnimation("done", ".mc-adding-lottie", ".add-to-cart-btn");
			}
			document.isChanged = false;
		});
}

function loadingAnimation(state, lottie, btnContent) {
	console.log("adding to cart");
	let addToCartLottie = document.querySelector(lottie);
	let addToCartText = document.querySelectorAll(btnContent);
	if (addToCartLottie) {
		if (state == "loading") {
			addToCartText.forEach((text) => {
				text.style.visibility = "hidden";
			});
			addToCartLottie.style.visibility = "visible";
		} else {
			addToCartText.forEach((text) => {
				text.style.visibility = "visible";
			});
			addToCartLottie.style.visibility = "hidden";
		}
	}
}

async function addClosetToCart() {
	if (
		!document
			.querySelector(".mc-checkout-addtocard")
			.classList.contains("add-to-cart-btn-disabled")
	) {
		if (!document.querySelector('.mc-checkout-addtocard').classList.contains('add-to-cart-btn-disabled')) {
			loadingAnimation("loading", ".mc-adding-lottie", ".add-to-cart-btn");
			try {
				// Capture the screenshot and wait for the promise to resolve
			const base64String = document.App.captureScreenshot(true).image;
				let variants = [];
				const canonicalColor = getCanonicalColor();
				const colorMismatch = towersArray.some((t) => t.color && t.color !== canonicalColor);
				if (colorMismatch) {
					console.error("Color mismatch detected across towers; normalizing to", canonicalColor);
				}
				// Assuming you want to use blobUrl for the image in the closet object
				const closet = {
					color: canonicalColor,
					customer: customerId,
					shop: shopId,
					image: base64String,
					towers: [],
				};

				// Your existing logic for processing towersArray and variants
				console.log("addToCart", towersArray, closet);
				towersArray.forEach((t) => {
					closet.towers.push({
						width: t.width.selectedValue,
						topOption: t.topOptions.selectedValue,
						bottomOption: t.bottomOptions.selectedValue,
						doorOption: t.doorOptions.selectedValue,
					});
					t.variants.forEach((v) => variants.push({ id: v.id }));
					t.topOptions.variants.forEach((v) => variants.push({ id: v.id }));
					t.bottomOptions.variants.forEach((v) => variants.push({ id: v.id }));
					t.doorOptions.variants.forEach((v) => variants.push({ id: v.id }));
				});

				let totalVariants = getTotalVariants(variants);
				const designId = getUrlParameter("designId");
				const action = designId ? "edit" : "add";
				saveCloset({ closet: closet }, totalVariants, action);
			} catch (error) {
				console.error("Failed to add closet to cart:", error);
			}
		}
	}
}

async function createDraftOrder() {
	console.log("Creating draft order!");
	if (
		!document
			.querySelector(".mc-checkout-addtocard")
			.classList.contains("add-to-cart-btn-disabled")
	) {
		loadingAnimation("loading", ".mc-adding-lottie", ".add-to-cart-btn");
		try {
			// Capture the screenshot and wait for the promise to resolve
			const base64String = document.App.captureScreenshot(true).image;
			let variants = [];
			// Assuming you want to use blobUrl for the image in the closet object
			const closet = {
				color: getCanonicalColor(),
				customer: customerId,
				shop: shopId,
				image: base64String,
				towers: [],
			};

			// Your existing logic for processing towersArray and variants
			console.log("addToCart", towersArray, closet);
			towersArray.forEach((t) => {
				closet.towers.push({
					width: t.width.selectedValue,
					topOption: t.topOptions.selectedValue,
					bottomOption: t.bottomOptions.selectedValue,
					doorOption: t.doorOptions.selectedValue,
				});
				t.variants.forEach((v) => variants.push({ id: v.id }));
				t.topOptions.variants.forEach((v) => variants.push({ id: v.id }));
				t.bottomOptions.variants.forEach((v) => variants.push({ id: v.id }));
				t.doorOptions.variants.forEach((v) => variants.push({ id: v.id }));
			});

			let totalVariants = getTotalVariants(variants);
			const designId = getUrlParameter("designId");
			const action = designId ? "edit" : "add";
			saveCloset({ closet: closet }, totalVariants, action, true);
		} catch (error) {
			console.error("Failed to add closet to cart:", error);
		}
	}
}

async function saveClosetToAccount(closetName = null) {
	const overrideButton = document.querySelector(".mc-override-btn");
	overrideButton && (overrideButton.style.background = "grey");
	loadingAnimation("loading", ".mc-popup-lottie", ".mc-popup-btn-content");
	try {
		// Capture the screenshot and wait for the promise to resolve
		const base64String = await document.App.captureScreenshot(true).image; // Ensure captureScreenshot is async or returns a Promise
		let variants = [];

		// Start constructing the closet object with mandatory fields
		const closet = {
			color: getCanonicalColor(),
			shop: shopId,
			image: base64String,
			towers: [],
		};

		// Add customer.id to the closet object if it's not null
		if (customerId && customerId !== "null") {
			closet.customer = customerId;
		}

		// Add name to the closet object if it's not null
		if (closetName) {
			const url = new URL(window.location.href);
			url.searchParams.delete("prompt"); // Remove the specified parameter
			window.history.replaceState(null, null, url);
			closet.name = closetName;
		}

		// Your existing logic for processing towersArray and variants
		console.log("Saving to account", towersArray, closet);
		towersArray.forEach((t) => {
			closet.towers.push({
				width: t.width.selectedValue,
				topOption: t.topOptions.selectedValue,
				bottomOption: t.bottomOptions.selectedValue,
				doorOption: t.doorOptions.selectedValue,
			});
			t.variants.forEach((v) => variants.push({ id: v.id }));
			t.topOptions.variants.forEach((v) => variants.push({ id: v.id }));
			t.bottomOptions.variants.forEach((v) => variants.push({ id: v.id }));
			t.doorOptions.variants.forEach((v) => variants.push({ id: v.id }));
		});

		let totalVariants = getTotalVariants(variants);
		// Always "save" (save-to-account path, not add-to-cart). The backend updates
		// the existing record when a designId is present, else creates a new one.
		saveCloset({ closet: closet }, totalVariants, "save");
	} catch (error) {
		console.error("Failed to saved closet:", error);
	}
}

async function saveClosetNoAccount(closetName) {
	// console.log(`Function saveClosetNoAccount called`);
	try {
		// Capture the screenshot and wait for the promise to resolve
		const base64String = await document.App.captureScreenshot(true).image; // Ensure captureScreenshot is async or returns a Promise
		let variants = [];

		// Start constructing the closet object with mandatory fields
		const closet = {
			color: getCanonicalColor(),
			// shop: "{{ shop.id }}",
			shop: shopId,
			image: base64String,
			towers: [],
		};

		// Add name to the closet object if it's not null
		if (closetName) {
			closet.name = closetName;
		}

		// Your existing logic for processing towersArray and variants
		console.log("Saving to account", towersArray, closet);
		towersArray.forEach((t) => {
			closet.towers.push({
				width: t.width.selectedValue,
				topOption: t.topOptions.selectedValue,
				bottomOption: t.bottomOptions.selectedValue,
				doorOption: t.doorOptions.selectedValue,
			});
			t.variants.forEach((v) => variants.push({ id: v.id }));
			t.topOptions.variants.forEach((v) => variants.push({ id: v.id }));
			t.bottomOptions.variants.forEach((v) => variants.push({ id: v.id }));
			t.doorOptions.variants.forEach((v) => variants.push({ id: v.id }));
		});

		let totalVariants = getTotalVariants(variants);
		const url = new URL(window.location);
		url.searchParams.set("prompt", true);
		history.pushState({ path: url.toString() }, "", url.toString());
		saveCloset({ closet: closet }, totalVariants, "saveNoAccount");
	} catch (error) {
		console.error("Failed to saved closet:", error);
	}
}

// --- New Customer Accounts: save-before-login handoff --------------------
// When a logged-out shopper saves, persist the design anonymously (with a
// one-time claimToken and the name they chose), then send them through
// Shopify's hosted login — preferably in a POPUP window so this page never
// navigates away. The popup returns to the storefront (same origin), claims
// the design, postMessages us, and closes; we then show the saved popup.
// Popup blocked → fall back to the full-page redirect flow.
async function saveDraftAndRedirectToLogin(closetName) {
	try {
		const base64String = await document.App.captureScreenshot(true).image;

		const claimToken =
			(window.crypto && crypto.randomUUID && crypto.randomUUID()) ||
			Date.now().toString(36) + Math.random().toString(36).slice(2);

		const closet = {
			color: getCanonicalColor(),
			shop: shopId,
			image: base64String,
			claimToken: claimToken,
			towers: [],
		};
		if (closetName) {
			closet.name = closetName;
		}

		towersArray.forEach((t) => {
			closet.towers.push({
				width: t.width.selectedValue,
				topOption: t.topOptions.selectedValue,
				bottomOption: t.bottomOptions.selectedValue,
				doorOption: t.doorOptions.selectedValue,
			});
		});

		const data = await closetDB(0, "saveDraft", { closet: closet });
		if (!data || !data.closetId) {
			throw new Error("saveDraft did not return a closetId");
		}

		// Stash the claim token in localStorage (keyed by designId). Shopify's
		// hosted login strips extra return_to query params, so we must NOT rely on
		// the URL to carry the token — and keeping it out of the URL is more secure.
		try {
			localStorage.setItem(
				"mc_pending_claim",
				JSON.stringify({ designId: data.closetId, token: claimToken })
			);
		} catch (e) {
			console.warn("Could not persist pending claim:", e);
		}

		// Try the popup-window flow first: popup_login=1 tells the returning page
		// (in the popup) to claim, notify us, and close itself.
		const popupReturnTo = `/collections/milano?designId=${encodeURIComponent(
			data.closetId
		)}&claim=${encodeURIComponent(claimToken)}&popup_login=1`;
		const popupUrl = `/customer_authentication/login?return_to=${encodeURIComponent(
			popupReturnTo
		)}`;
		const loginWindow = window.open(popupUrl, "mcLogin", "width=520,height=720");

		if (loginWindow) {
			const onClaimMessage = function (event) {
				if (event.origin !== window.location.origin) return;
				if (!event.data || !event.data.mcClaimed) return;
				window.removeEventListener("message", onClaimMessage);
				// This page rendered logged-out (customerId empty); adopt the id from
				// the popup so later saves/add-to-cart use the real customer.
				if (event.data.customerId) {
					customerId = String(event.data.customerId);
				}
				try {
					localStorage.removeItem("mc_pending_claim");
				} catch (e) {}
				// Reflect the saved design in our URL and confirm with the popup.
				const url = new URL(window.location);
				url.searchParams.set("designId", event.data.designId);
				history.pushState({ path: url.toString() }, "", url.toString());
				exitPopup();
				showPopup("milano-saved-popup", { closetId: event.data.designId });
			};
			window.addEventListener("message", onClaimMessage);
			return;
		}

		// Popup blocked → full-page redirect (original flow, without popup_login).
		const returnTo = `/collections/milano?designId=${encodeURIComponent(
			data.closetId
		)}&claim=${encodeURIComponent(claimToken)}`;
		window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(
			returnTo
		)}`;
	} catch (error) {
		console.error("Failed to save draft before login:", error);
		// Fallback so the shopper isn't stuck: send to hosted login and back.
		window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(
			window.location.pathname + window.location.search
		)}`;
	}
}

// Attach an anonymous draft design to the logged-in customer after they return
// from hosted login. Direct backend call (same trust model as the other saves) —
// secured by the one-time claimToken, so it does not depend on the app proxy.
function claimDesign(designId, claimToken) {
	const endpoint = `https://modular-bundles--development.gadget.app/milano/claim/${designId}`;
	return fetch(endpoint, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ claimToken: claimToken, customer: customerId }),
	})
		.then((r) => r.json())
		.catch((error) => {
			console.error("Claim request failed:", error);
			return { success: false };
		});
}

function downloadAsPDF() {
	const hidePrices = document.querySelector('.mc-hide-prices')?.querySelector('input').checked;

	canvasOverlay = document.querySelector(".mc-loading-overlay");
	overlayText = canvasOverlay.querySelector(".mc-loading");
	overlayText.innerText = "Downloading...";
	canvasOverlay.style["z-index"] = "2";
	canvasOverlay.style.display = "flex";
	let hasDoors = false;
	document.isChanged = "downloading";
	// test endpoint
	// const endpoint =
	//   "https://k1torvcba1.execute-api.us-east-1.amazonaws.com/prod/generateClosetDesignPDF";

	// New proper endpoint, not ready yet
	// const endpoint = "https://glwez4008e.execute-api.us-east-1.amazonaws.com/Prod/download-milano-packing-slip"

	//lambda endpoint
	const endpoint =
		"https://3qtf65iqcepntqftchr4pef3ri0bvyck.lambda-url.us-east-1.on.aws/download-milano-packing-slip";

	const gcpEndpoint = "https://modular-pdf-generation-ltf3yktx4q-ue.a.run.app/download-milano-packing-slip";

	let variants = [];
	let parts = [];
	const closet = {
		color: getCanonicalColor(),
		image_url_door_open: "",
		image_url_door_closed: "",
		closet_name: closetName || "",
		total_price: towersArray[0].totalPrice / 100,
		towers: [],
	};

	towersArray.forEach((t) => {
		if (t.doorOptions.selectedValue != "none") {
			hasDoors = true;
		}
		closet.towers.push({
			width: parseFloat(t.width.selectedValue),
			top:
				t.topOptions.selectedValue == "short-hanging"
					? "Hanging"
					: t.topOptions.selectedValue
						.split("-")
						.map((word) => {
							return (
								word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
							);
						})
						.join(" "),
			top: t.topOptions.selectedValue == 'short-hanging' ? 'Hanging' : t.topOptions.selectedValue
				.split("-")
				.map((word) => {
					return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
				})
				.join(" "),
			bottom: t.bottomOptions.selectedValue
				.split("-")
				.map((word) => {
					return ["of", "over"].includes(word)
						? word
						: word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
				})
				.join(" "),
			door:
				t.doorOptions.selectedValue.split("-")[0].charAt(0).toUpperCase() +
				t.doorOptions.selectedValue.split("-")[0].slice(1).toLowerCase(),
		});
		t.variants.forEach((v) =>
			variants.push({
				id: v.id,
				title: v.productTitle.replace('(1)', '').replace('(2)', ''),
				variant_title: v.description.replace('(1)', '').replace('(2)', ''),
				name: v.name.replace('(1)', '').replace('(2)', ''),
				price: v.price / 100,
				image_url: v.image,
				sku: v.sku,
			})
		);
		t.topOptions.variants.forEach((v) =>
			variants.push({
				id: v.id,
				title: v.productTitle.replace('(1)', '').replace('(2)', ''),
				variant_title: v.description.replace('(1)', '').replace('(2)', ''),
				name: v.name.replace('(1)', '').replace('(2)', ''),
				price: v.price / 100,
				image_url: v.image,
				sku: v.sku,
			})
		);
		t.bottomOptions.variants.forEach((v) =>
			variants.push({
				id: v.id,
				title: v.productTitle.replace('(1)', '').replace('(2)', ''),
				variant_title: v.description.replace('(1)', '').replace('(2)', ''),
				name: v.name.replace('(1)', '').replace('(2)', ''),
				price: v.price / 100,
				image_url: v.image,
				sku: v.sku,
			})
		);
		t.doorOptions.variants.forEach((v) =>
			variants.push({
				id: v.id,
				title: v.productTitle.replace('(1)', '').replace('(2)', ''),
				variant_title: v.description.replace('(1)', '').replace('(2)', ''),
				name: v.name.replace('(1)', '').replace('(2)', ''),
				price: v.price / 100,
				image_url: v.image,
				sku: v.sku,
			})
		);
	});
	let variantIdQuantity = getTotalVariants(variants);
	// let totalVariants = [];
	variantIdQuantity.forEach((viq) => {
		parts.push({
			...variants.find((v) => {
				return v.id == viq.id;
			}),
			qty: viq.quantity,
		});
	});

	// setDoorsState("Open Doors");
	// setTimeout(() => {
	// closet.openDoorsImg = document.App.captureScreenshot();
	// closet.image_url_door_open =
	// 	document.App.captureScreenshotPerspectiveFromSetAngle().image;
	closet.image_url_door_open =
		document.App.captureScreenshot(true).image;  
	// setDoorsState("Close Doors");
	// setTimeout(() => {
	closet.image_url_door_closed = hasDoors
		? document.App.captureScreenshot(false).image
		: null;

	closet.parts = parts;

	console.log("JSON.stringify({ closet })", JSON.stringify({ closet }));

	// fetch(endpoint, {
	//   method: "POST",
	//   headers: {
	//     "Content-Type": "application/json",
	//   },
	//   body: JSON.stringify({ closet }),
	// })
	// fetch(endpoint, {
	//   method: "POST",
	//   headers: {
	//     "Content-Type": "application/json",
	//   },
	//   body: JSON.stringify({
	//     towers: closet.towers,
	//     parts: closet.parts,
	//     color: closet.color,
	//     total_price: closet.total_price
	//   }),
	//   }).then((response) => {
	//     console.log("Response:", response);
	//     if (!response.ok) {
	//       throw new Error("Network response was not ok");
	//     }

	//     return response.json();
	//   })
	//   .then((data) => {
	//     console.log("data json", data);
	//     const pdfUrl = data.url;
	//     const message = document.createElement("p");
	//     message.style.visibility = "hidden";
	//     message.style.position = "absolute";
	//     message.innerHTML = `<a href="${pdfUrl}" download="${
	//       closetName || "MilanoDesign"
	//     }.pdf"></a>`;
	//     document.body.appendChild(message);
	//     message.querySelector("a").click();
	//   })
	//   .catch((error) => {
	//     console.error("Error:", error);
	//     throw error;
	//   })
	//   .finally(() => {
	//     canvasOverlay.style.display = "none";
	//     console.log("closet", closet, "variants", parts);
	//   });
	// }, delay);
	// }, 2000);

	if(hidePrices){
		closet.total_price = discountAmount = discountPercent = discountedTotal = null;
	}

	// Prepare the payload
	const payload = {
		towers: closet.towers,
		parts: closet.parts,
		color: closet.color,
		image_url_door_open: closet.image_url_door_open,
		image_url_door_closed: closet.image_url_door_closed,
		closet_name: closet.closet_name,
		color: closet.color,
		total_price: discountedTotal || closet.total_price,
		total_before_discount: closet.total_price,
		discount_amount: discountAmount,
		discount_percent: discountPercent,
	};

	// Log the payload (excluding images)
	const payloadToLog = {
		towers: closet.towers,
		parts: closet.parts,
		color: closet.color,
		closet_name: closet.closet_name,
		total_price: discountedTotal || closet.total_price,
		total_before_discount: closet.total_price,
		discount_amount: discountAmount,
		discount_percent: discountPercent,
	};

	// console.log("Payload:", JSON.stringify(payloadToLog, null, 2));

	// Send the payload
	fetch(gcpEndpoint, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(payload),
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			// Check if the response is PDF by inspecting the headers or other characteristics
			const contentType = response.headers.get("content-type");
			if (contentType && contentType.includes("application/pdf")) {
				return response.blob(); // Handle PDF files
			}
			throw new Error("Expected PDF, but did not receive PDF");
		})
		.then((blob) => {
			// Create a URL for the PDF and trigger a download
			const pdfUrl = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = pdfUrl;
			link.setAttribute("download", `${closetName || "MilanoDesign"}.pdf`);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link); // Clean up
		})
		.catch((error) => {
			console.error("Error:", error);
		})
		.finally(() => {
			canvasOverlay.style.display = "none";
			console.log("Closet:", closet, "Variants:", parts);
		});
}

function downloadAsPDFV2() {
	canvasOverlay = document.querySelector(".mc-loading-overlay");
	overlayText = canvasOverlay.querySelector(".mc-loading");
	overlayText.innerText = "Downloading...";
	canvasOverlay.style["z-index"] = "2";
	canvasOverlay.style.display = "flex";
	let hasDoors = false;
	document.isChanged = "downloading";

	const endpoint =
		"https://3qtf65iqcepntqftchr4pef3ri0bvyck.lambda-url.us-east-1.on.aws/download-milano-packing-slip";

	let towers = [];
	let parts = [];

	// Transform tower and parts data accordingly
	towersArray.forEach((t) => {
		if (t.doorOptions.selectedValue != "none") {
			hasDoors = true;
		}

		// Function to transform door options
		const transformDoorOption = (doorValue) => {
			const parts = doorValue.split("-");
			const formattedParts = parts.map(
				(part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
			);
			return formattedParts.join(" ");
		};

		// Transform tower specs - include logic to transform based on API expectations
		towers.push({
			width: parseFloat(t.width.selectedValue),
			top: transformTowerOption(t.topOptions.selectedValue),
			bottom: transformTowerOption(t.bottomOptions.selectedValue),
			door:
				t.doorOptions.selectedValue != "none"
					? transformDoorOption(t.doorOptions.selectedValue)
					: "",
		});

		// Consolidate all parts and quantify them
		collectAndQuantifyParts(t, parts);
	});

	// Prepare images with doors state
	const imageUrlDoorOpen =
		document.App.captureScreenshot(true).image;
	const imageUrlDoorClosed = hasDoors ? document.App.captureScreenshot(false).image : null;

	const payload = {
		towers: towers,
		parts: parts,
		closet_name: closetName || "",
		color: getCanonicalColor().toUpperCase(),
		total_price: towersArray[0].totalPrice / 100,
		image_url_door_open: imageUrlDoorOpen,
		image_url_door_closed: imageUrlDoorClosed || "",
	};

	console.log("payload", payload);

	sendPayloadToLambda(endpoint, payload);
}

// Additional supporting functions to transform data
function transformTowerOption(option) {
	return option
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");
}

function collectAndQuantifyParts(tower, partsAccumulator) {
	tower.variants.forEach((variant) => {
		console.log("variant", variant);
		const existingPartIndex = partsAccumulator.findIndex(
			(p) => p.id === variant.id
		);
		if (existingPartIndex >= 0) {
			partsAccumulator[existingPartIndex].qty += 1;
		} else {
			partsAccumulator.push({
				id: variant.id,
				title: variant.productTitle,
				variant_title: variant.description,
				name: variant.name,
				price: variant.price / 100,
				image_url: variant.image || "",
				qty: 1,
				sku: variant.sku || "",
			});
		}
	});
}

function sendPayloadToLambda(endpoint, payload) {
	fetch(endpoint, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(payload),
	})
		.then(handleResponse)
		.catch(handleError)
		.finally(cleanupUI);
}

// This function processes the response from the Lambda function. It should check if the response is successful, retrieve the data, and then trigger the download of the PDF // file.

function handleResponse(response) {
	console.log("Lambda response:", response);
	if (!response.ok) {
		throw new Error("Network response was not ok.");
	}
	return response.json().then((data) => {
		if (data.url) {
			const pdfUrl = data.url;
			const link = document.createElement("a");
			link.href = pdfUrl;
			link.download = closetName || "MilanoDesign.pdf";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link); // Clean afterward
		} else {
			throw new Error("No PDF URL found in the response.");
		}
	});
}

//This function manages errors that may occur during the fetch operation or within the `handleResponse` method.
function handleError(error) {
	console.error("Error occurred:", error);
	alert("Failed to download PDF: " + error.message);
}

//This function is responsible for resetting the UI elements affected during the processing, such as hiding overlays or removing loading indicators.
function cleanupUI() {
	if (canvasOverlay) {
		canvasOverlay.style.display = "none";
	}
	overlayText.innerText = ""; // Reset text to default or whatever it was before
	console.log("Cleanup completed. UI reset.");
}

function getTotalVariants(variants) {
	const counts = new Map();
	variants.forEach((v) => {
		counts.set(v.id, (counts.get(v.id) || 0) + 1);
	});
	return Array.from(counts, ([id, quantity]) => ({ id, quantity }));
}

// function checkForChanges() {
// 	if (document.isChanged && document.isChanged !== "downloading") {
// 		var message = "Changes have not been saved.";
// 		return message;
// 	}
// 	return null;
// }

// window.onbeforeunload = function (event) {
// 	var message = checkForChanges();
// 	if (message) {

// 		if (typeof event == "undefined") {
// 			event = window.event;
// 		}
// 		if (event) {
// 			event.returnValue = message;
// 		}
// 		return message;
// 	}
// };

let closetName;

function getClosetById(id) {
	return closetDB(id)
		.then((data) => {
			console.log("Received data:", data);

			if (data.closet.name) {
				closetName = data.closet.name;
				console.log("Closet name available:", closetName);
			}

			const closet = {
				color: data.closet.color,
				towers: [],
			};
			data.closet.towers.edges.forEach((t) => {
				closet.towers.push({
					...t.node,
					width: String(t.node.width),  // DB returns width as Float; convert to string for all downstream comparisons
				});
			});
			console.log("myCloset", closet);
			buildCloset(closet, { isChanged: false });
			// document.querySelector(".mc-loading-overlay").style.display = "none";
			endLoader();
		})
		.catch((error) => {
			console.error("Request failed:", error);
		});
}

// function loadPredesign(id) {
//   resetScene({ instant: true });
//   getClosetById(id);
// }

function removeParamFromURL(param) {
	// Get the current URL
	const url = new URL(window.location.href);
	// Delete the parameter from the URL
	url.searchParams.delete(param);
	// Update the URL in the browser without reloading the page
	window.history.replaceState({}, document.title, url.toString());
}

function loadPredesign(id) {
	canvasOverlay = document.querySelector(".mc-loading-overlay");
	overlayText = canvasOverlay.querySelector(".mc-loading");
	overlayText.innerText = "Loading design...";
	canvasOverlay.style["z-index"] = "4";
	canvasOverlay.style.display = "flex";
	// var message = checkForChanges();
	// let saveFirst;
	// if (message) {
	// 	saveFirst = confirm(message + '\nSave changes?');
	// }
	// if (!saveFirst) {
	const loadTimeout = setTimeout(() => {
		const msg = document.querySelector(".mc-loading-overlay .mc-loading");
		if (msg) {
			msg.innerText = "Error loading design. Please refresh the page.";
		}
	}, 10000);

	// Perform your resetScene and getClosetById functions
	resetScene({ instant: true });
	getClosetById(id)
		.then(() => {
			clearTimeout(loadTimeout);
			// Remove the 'designId' parameter after successful load
			removeParamFromURL("designId");
		})
		.catch(() => {
			clearTimeout(loadTimeout);
		});

	// Scroll to the #configurator section
	// const configuratorElement = document.querySelector("#configurator");
	// if (configuratorElement) {
	// 	configuratorElement.scrollIntoView({ behavior: "smooth", block: "start" });
	// }
	scrollToConfigurator();
	// }
}

function buildCloset(closet, { isChanged }) {
	closet.towers.forEach((tower) => {
		addTower(closet.color, tower, isChanged);
	});
}

function exitPopup() {
	let popup = document.querySelector(".mc-popup-overlay-container");
	popup.style.display = "none";
}

function popupSave() {
	closetName = document.querySelector(".mc-popup-input")?.value || closetName;
	console.log("save my closet design name", name);
	// Logged out: save the named draft and send the shopper through hosted login
	// (popup window when possible) so the design gets linked to their account.
	if (!customerId) {
		saveDraftAndRedirectToLogin(closetName);
		return;
	}
	// loadingAnimation('loading', '.mc-popup-lottie', '.mc-popup-btn-content');
	saveClosetToAccount(closetName);

	//   setTimeout(() => {
	//     exitPopup();
	//     loadingAnimation('done', '.mc-popup-lottie', '.mc-popup-btn-content');
	// }, 2000);
}

function toggleMeasurementsVisibility() {
	// Get all buttons with the ID 'toggleMeasurements'. Using class would be more appropriate if multiple elements are involved.
	let toggleMeasurementsBtns = document.querySelectorAll("#toggleMeasurements");

	// Loop through each button and update the text based on its current state
	toggleMeasurementsBtns.forEach(function (btn) {
		if (btn.innerText === "Hide Measurements") {
			btn.innerText = "Show Measurements";
		} else {
			btn.innerText = "Hide Measurements";
		}
	});

	document.App.toggleVisibility();
	document.App.toggleVisibilityGroup();
}

function setDoorsState(state) {
	switch (state) {
		case "Close Doors":
			towersArray.forEach((t) => {
				document.CabinetVars.SelectedIndex = t.towerCounter - 1;
				t.doorOptions.closeDoors();
			});
			// toggleDoorsBtn.innerText = 'Open Doors';
			// break;
			return "Open Doors";
		case "Open Doors":
			towersArray.forEach((t) => {
				document.CabinetVars.SelectedIndex = t.towerCounter - 1;
				t.doorOptions.openDoors();
			});
			return "Close Doors";
		// toggleDoorsBtn.innerText = 'Close Doors';
	}
}

function disableEnableAction(action, disable) {
	switch (action) {
		case "doors":
			let toggleDoorsBtn = document.querySelectorAll("#toggleDoorsAction");
			if (disable) {
				if (!toggleDoorsBtn[0].classList.contains("mc-action-disable")) {
					toggleDoorsBtn.forEach((tdb) => {
						tdb.classList.add("mc-action-disable");
					});
				}
			} else {
				toggleDoorsBtn.forEach((tdb) => {
					tdb.classList.remove("mc-action-disable");
				});
			}
	}
}

function getToggleDoorsState() {
	let toggleDoorsBtn = document.querySelectorAll("#toggleDoors");
	return toggleDoorsBtn[0].innerText;
}

function toggleDoors() {
	let toggleDoorsAction = document.querySelectorAll("#toggleDoorsAction");
	let toggleDoorsBtn = document.querySelectorAll("#toggleDoors");
	// console.log("toggledoors", toggleDoorsBtn.innerText);
	if (!toggleDoorsAction[0].classList.contains("mc-action-disable")) {
		currentTower = document.CabinetVars.SelectedIndex;
		toggleValue = setDoorsState(toggleDoorsBtn[0].innerText);
		toggleDoorsBtn.forEach((tdb) => {
			tdb.innerText = toggleValue;
		});

		console.log("toggledoors", toggleDoorsBtn[0].innerText);
		console.log(
			"current index",
			currentTower,
			document.CabinetVars.SelectedIndex
		);
		document.CabinetVars.SelectedIndex = currentTower;
	}
}

function deleteDesign() {
	const url = new URL(window.location);
	url.searchParams.delete("designId");
	history.pushState({}, "", url);
	resetScene();
	// exitPopup();
	disableAddtoCart();
	showPopup("milano-all-clear");
}

let discountPercent, discountAmount, discountedTotal;
function updateDiscount(input) {
	discountPercent = input
		? parseFloat(input.value)
		: document.querySelector(".discount-percent").querySelector("input").value;
	if (isNaN(discountPercent)) {
		input.value = "";
		discountPercent = 0;
	}
	if (value < 0) {
		input.value = valdiscountPercentue = 0;
	}
	if (value > 100) {
		input.value = discountPercent = 100;
	}
	discountAmount = (towersArray[0].totalPrice * discountPercent) / 10000;
	discountedTotal =
		(towersArray[0].totalPrice * (100 - discountPercent)) / 10000;
	console.log(
		"updatediscount",
		discountPercent,
		discountAmount,
		discountedTotal
	);
	// let discountInput = document
	// 	.querySelector(".discount-amount")
	// 	.querySelector("input");
	// discountInput.value = discountAmount;
	// let totalInput = document
	// 	.querySelector(".discounted-price")
	// 	.querySelector("input");
	// totalInput.value = discountedTotal;
	let discountAmountDiv = document.querySelector(".discount-amount .discount-value");
	discountAmountDiv.textContent = discountAmount.toFixed(2);

	let discountedTotalDiv = document.querySelector(".discounted-price .discounted-value");
	discountedTotalDiv.textContent = discountedTotal.toFixed(2);
	let draftTotalAmountText = document.getElementById("draft-total-amount");

	draftTotalAmountText.textContent = discountedTotal.toFixed(2);;
}

function initLottie(id) {
	console.log("init", id);
	var animation = lottie.loadAnimation({
		container: document.getElementById(`lottie-container-${id}`), // the container element
		renderer: "svg", // rendering format, 'svg' is default
		loop: true, // if you want it to loop
		autoplay: true, // if you want it to start automatically
		animationData: animationData, // the animation data
	});
}

function fadeContent(popupOverlay) {
	console.log("fadein", popupOverlay);
	let content = popupOverlay.querySelector(".mc-popup-content");
	content.style.opacity = 1;
	if (!popupOverlay.querySelector(".mc-popup-exit-icon")) {
		setTimeout(() => {
			popupOverlay.style.display = "none";
		}, 2000);
	}
}

// funtion to check if desginId in url
function getUrlParameter(name) {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(name);
}
// Check if there's a designId in the URL
const designId = getUrlParameter("designId");

let milanoConfiguratorInitialized = false;
function onClosetConfiguratorReady(event) {
	// The Milano 3D engine can dispatch closetConfiguratorReady during its module
	// init — before this deferred script attaches its listener below — so we also
	// invoke this directly when the engine is already ready. Guard: run once.
	if (milanoConfiguratorInitialized) return;
	milanoConfiguratorInitialized = true;

	console.log("Closet configurator is ready!");
	const designIdNow = getUrlParameter("designId");
	const hasReloaded = sessionStorage.getItem("hasReloaded");

	if (designIdNow) {
		// If we've just returned from hosted login, attach the anonymous draft to
		// the now-logged-in customer before loading it. The token was stashed in
		// localStorage before the redirect (keyed by designId).
		let pendingClaim = null;
		try {
			pendingClaim = JSON.parse(localStorage.getItem("mc_pending_claim") || "null");
		} catch (e) {
			pendingClaim = null;
		}
		const storedToken =
			pendingClaim && String(pendingClaim.designId) === String(designIdNow)
				? pendingClaim.token
				: null;
		const claimToken = storedToken || getUrlParameter("claim");

		// Popup-login mode: this page is the small login popup returning from
		// Shopify. Claim the design, hand the result to the opener (the still-open
		// configurator), and close — don't load the full tool in the popup.
		if (getUrlParameter("popup_login") && window.opener && customerId) {
			const finish = () => {
				try {
					// Include customerId: the opener rendered logged-out, so its own
					// customerId is still empty until we hand it over.
					window.opener.postMessage(
						{ mcClaimed: true, designId: designIdNow, customerId: customerId },
						window.location.origin
					);
				} catch (e) {}
				window.close();
			};
			(claimToken
				? claimDesign(designIdNow, claimToken)
				: Promise.resolve()
			).then(finish, finish);
			return;
		}

		const claimFirst =
			claimToken && customerId
				? claimDesign(designIdNow, claimToken).finally(() => {
						try {
							localStorage.removeItem("mc_pending_claim");
						} catch (e) {}
						removeParamFromURL("claim");
				  })
				: Promise.resolve();

		claimFirst
			.then(() => getClosetById(designIdNow))
			.then(() => {
				removeParamFromURL("designId");
				// If we just returned from the save → hosted-login flow, confirm the
				// save with the same popup shown after a normal save.
				if (claimToken && customerId) {
					showPopup("milano-saved-popup", { closetId: designIdNow });
				}
			})
			.catch((err) => {
				console.error("Failed to load design:", err);
			});
		if (getUrlParameter("prompt") && customerId) {
			showPopup("milano-save-popup");
		}
	} else if (getUrlParameter("reset_password")) {
		showPopup("reset-password-success");
		// Clear the parameter by modifying the URL without reloading the page
		var url = new URL(window.location.href);
		url.searchParams.delete("reset_password");
		window.history.replaceState({}, "", url.toString());
	} else {
		try {
			addTower();
			endLoader();
		} catch (error) {
			console.error("Error in addTower():", error);
			// If the specific error is detected, call resetScene() and try adding the tower again
			if (
				error.message.includes(
					"Cannot read properties of undefined (reading 'position')"
				) || error.message.includes("X is undefined")
			) {
				resetScene();
				try {
					addTower();
					// Reset the flag if the second attempt is successful
					sessionStorage.removeItem("hasReloaded");
					endLoader();
				} catch (retryError) {
					console.error("Retrying addTower() failed:", retryError);
					// Retry a third time after 4.5 seconds if the error persists
					setTimeout(() => {
						resetScene();
						try {
							addTower();
							// Reset the flag if the third attempt is successful
							sessionStorage.removeItem("hasReloaded");
							endLoader();
						} catch (thirdRetryError) {
							console.error(
								"Third attempt of addTower() failed:",
								thirdRetryError
							);
							// Reload the page if the third attempt also fails and the page hasn't already reloaded
							if (!hasReloaded) {
								sessionStorage.setItem("hasReloaded", "true");
								window.location.reload();
							}
						}
					}, 4500);
				}
			}
		}
	}
}

window.addEventListener("closetConfiguratorReady", onClosetConfiguratorReady);

// Race fix: the Milano engine often fires closetConfiguratorReady before this
// deferred script attaches the listener above. If the engine already initialized
// (document.App is set), the event already fired and we missed it — run init now.
// The run-once guard ensures it still fires only once if the event arrives later.
if (typeof document !== "undefined" && document.App) {
	onClosetConfiguratorReady();
}

window.addEventListener("closetConfiguratorError", function (event) {
	console.error("Error loading configurator:", event.detail.error);
	const canvasOverlay = document.querySelector(".mc-loading-overlay");
	if (canvasOverlay) {
		const overlayText = canvasOverlay.querySelector(".mc-loading");
		if (overlayText) {
			overlayText.innerText = "Error loading configurator. Please refresh the page.";
		}
	}
});

function endLoader() {
	console.log('cabinets', document.App.cabinets.length);
	if (document.App.cabinets.length) {
		isAddTowerEnabled("active");
		document.querySelector(".mc-loading-overlay").style.display = "none";
		loadingAnimation("done", ".mc-adding-lottie", ".add-to-cart-btn");
	}
}



function waitForDependencies(callback) {
	console.log("Checking for dependencies...");
	if (typeof Tower !== "undefined" && document.App && document.App.positions) {
		console.log("Dependencies are ready.");
		console.log(
			"Tower:",
			Tower,
			"document.App.positions",
			document.App.positions
		);
		callback();
	} else {
		console.log("Dependencies not ready, checking again in 100ms...");
		// Log the current state of Tower and document.App.positions for debugging
		console.log("Tower defined:", typeof Tower !== "undefined");
		console.log(
			"document.App.positions defined:",
			document.App ? !!document.App.positions : "document.App is undefined"
		);
		setTimeout(() => waitForDependencies(callback), 100); // Check every 100ms
	}
}

// // Usage
// waitForDependencies(() => {
//     if (designId) {
//         console.log('Fetching closet by ID:', designId);
//         getClosetById(designId);
//     } else {
//         console.log('Adding tower because designId is not present.');
//         // addTower();
//         // document.querySelector('.mc-loading-overlay').style.display = 'none';
//     }
// });

//drag events
// document.addEventListener('DOMContentLoaded', () => {
const towersContainer = document.querySelector(".mc-towers");
let dragSrcEl = null; // The item being dragged.

function handleDragStart(e) {
	dragSrcEl = this;
	e.dataTransfer.effectAllowed = "move";
	e.dataTransfer.setData("text/html", this.outerHTML);

	this.classList.add("dragging");
}

function handleDragOver(e) {
	e.preventDefault(); // Necessary to allow dropping.
	e.dataTransfer.dropEffect = "move"; // See the section on the DataTransfer object.
}

function handleDragEnter(e) {
	this.classList.add("over");
}

function handleDragLeave(e) {
	this.classList.remove("over");
}

function handleDrop(e) {
	e.stopPropagation(); // Stops the browser from redirecting.
	e.preventDefault();

	if (dragSrcEl !== this) {
		// Find the target's index
		const targetIndex = parseInt(this.getAttribute("data-index"));
		const srcIndex = parseInt(dragSrcEl.getAttribute("data-index"));

		// Decide where to insert the dragged element
		if (srcIndex < targetIndex) {
			this.parentNode.insertBefore(dragSrcEl, this.nextSibling);
		} else {
			this.parentNode.insertBefore(dragSrcEl, this);
		}

		updateIndices();
	}
}

function handleDragEnd(e) {
	this.classList.remove("dragging");
	towersContainer.querySelectorAll(".draggable").forEach(function (item) {
		item.classList.remove("over");
	});
}

function handleTouchStart(e) {
	console.log("touchstart");
	e.preventDefault();
	dragSrcEl = this;
	dragSrcEl = dragSrcEl.closest(".mc-tower");
	console.log("dragSrcEl touchstart", dragSrcEl);
}

function handleTouchMove(e) {
	console.log("touchmove");
	e.preventDefault();
}

function handleTouchEnd(e) {
	console.log("touchend");
	e.preventDefault(); // Prevent default actions like clicking

	// Determine the drop target. This requires finding the element under the touch.
	// This can be complex in touch environments and might require elements to track their own positions.
	var touch = e.changedTouches[0];
	var target = document.elementFromPoint(touch.clientX, touch.clientY);
	var targetTower = target.closest(".mc-tower");
	console.log("touchend", target, touch, targetTower);
	if (
		dragSrcEl !== targetTower &&
		targetTower &&
		targetTower.getAttribute("data-index")
	) {
		const targetIndex = parseInt(targetTower.getAttribute("data-index"));
		const srcIndex = parseInt(dragSrcEl.getAttribute("data-index"));
		console.log("target", targetIndex, "src", srcIndex);
		// Decide where to insert the dragged element
		if (srcIndex < targetIndex) {
			targetTower.parentNode.insertBefore(dragSrcEl, targetTower.nextSibling);
		} else {
			targetTower.parentNode.insertBefore(dragSrcEl, targetTower);
		}

		updateIndices();
	}
}

function addDnDEvents(elem) {
	console.log("addDnDEvents elem", elem);
	dragSpace = elem.querySelector(".mc-options-icon");
	elem.addEventListener("dragstart", handleDragStart, false);
	elem.addEventListener("dragenter", handleDragEnter, false);
	elem.addEventListener("dragover", handleDragOver, false);
	elem.addEventListener("dragleave", handleDragLeave, false);
	elem.addEventListener("drop", handleDrop, false);
	elem.addEventListener("dragend", handleDragEnd, false);
	//touch
	dragSpace.addEventListener("touchstart", handleTouchStart, false);
	// elem.addEventListener('touchmove', handleTouchMove, false);
	dragSpace.addEventListener("touchmove", handleTouchMove, false);
	// elem.addEventListener('touchend', handleTouchEnd, false);
	dragSpace.addEventListener("touchend", handleTouchEnd, false);
}

function updateIndices() {
	let towers = towersContainer.querySelectorAll(".mc-tower");
	let indices = [];
	towers.forEach((tower) => {
		indices.push(tower.getAttribute("id").substring(1));
	});
	let fromIndex = null;
	let toIndex = null;
	for (let i = 1; i <= indices.length; i++) {
		console.log("i", i, "indices of i", indices[i - 1]);
		if (i != indices[i - 1]) {
			toIndex = fromIndex ? i : null;
			fromIndex = fromIndex || i;
		}
	}
	moveTower(--fromIndex, --toIndex);
}

function calculateMonthlyPayment(loanAmount, loanTermMonths = 36, apr = 9.99) {
	const monthlyInterestRate = apr / 100 / 12;
	const monthlyPayment =
		(monthlyInterestRate * loanAmount) /
		(1 - Math.pow(1 + monthlyInterestRate, -loanTermMonths));
	return monthlyPayment;
}
